import React, { Component } from "react";
import {
  getProductUnitByProductIdRequest,
  updateProductUnitStatusByProductUnitIdRequest,
  deleteProductUnitByProductUnitIdRequest,
} from "store/actions";

import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";
import Switch from "react-switch";
import { makeProductUnitSelectField } from "store/ProductUnit/selector";
import { createStructuredSelector } from "reselect";
import CustomDataTable from "components/Application/CustomDataTable";
import CustomisedModal from "components/Application/CustomisedModal";
import { confirmBox } from "helpers/messageHelper";

import ManageUnitForm from "./ManageUnitForm";
import { primaryColor, secondaryColor } from "scss/variables.module.scss";

// saga & redux
import injectReducer from "helpers/injectReducer";
import injectSaga from "helpers/injectSaga";
import productUnitReducer from "store/ProductUnit/reducer";
import productUnitSaga from "store/ProductUnit/saga";
import CircularIconButton from "components/Buttons/CircularIconButton";

const productUnitKey = "ProductUnit";

const withProductUnitReducer = injectReducer({
  key: productUnitKey,
  reducer: productUnitReducer,
});
const withProductUnitSaga = injectSaga({
  key: productUnitKey,
  saga: productUnitSaga,
});

const columns = [
  {
    label: "Unit",
    field: "unit",
  },
  {
    label: "MRP",
    field: "unitMRP",
  },
  {
    label: "Selling Price",
    field: "unitSP",
  },
  {
    label: "Quantity",
    field: "unitQty",
  },
  {
    label: "Is Multi Unit",
    field: "isMultiUnit",
  },
  {
    label: "Status",
    field: "status",
    sort: "disabled",
  },
  {
    label: "Actions",
    field: "actions",
    sort: "disabled",
  },
];

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      productUnitData: [],
      productUnitRecord: null,
    };
  }

  componentDidMount() {
    //Retrieve productUnit list
    this.props.getProductUnitByProductIdRequest(this.props.productDetailId);
  }

  onStatusChange = (checked, e, id) => {
    this.props.updateProductUnitStatusByProductUnitIdRequest(id, checked);
  };

  buildProductUnitDataTable = (records) => {
    this.setState({
      productUnitData: records.map((productUnit) => {
        let actions = (
          <div className="text-center">
            <CircularIconButton
              icon="far fa-edit fa-lg"
              onClick={this.viewProductUnit(productUnit)}
              tooltip={"Edit"}
            />

            <CircularIconButton
              icon="far fa-trash-alt fa-lg"
              onClick={this.deleteProductUnit(productUnit.productUnitId)}
              tooltip={"Delete"}
            />
          </div>
        );

        let status = (
          <div className="d-flex">
            <Switch
              className="switch-sm"
              onColor={primaryColor}
              offColor={secondaryColor}
              onChange={(checked, e, id) => this.onStatusChange(checked, e, id)}
              id={productUnit.productUnitId + ""}
              checked={productUnit.status ? true : false}
            />
            &nbsp;
          </div>
        );

        return {
          unit: productUnit.unitVariant,
          unitMRP: productUnit.unitMRP,
          unitSP: productUnit.unitSP,
          unitQty: productUnit.unitQty,
          isMultiUnit: productUnit.isMultiUnit ? "Yes" : "No",
          status: status,
          actions: actions,
        };
      }),
    });
  };

  UNSAFE_componentWillReceiveProps(nextprops) {
    if (this.props.productUnitData !== nextprops.productUnitData) {
      this.buildProductUnitDataTable(nextprops.productUnitData);
    }
  }

  viewProductUnit = (productUnitData) => () => {
    this.setState({
      productUnitRecord: productUnitData,
    });
  };

  deleteProductUnit = (productUnitId) => async () => {
    const response = await confirmBox();
    if (response) {
      this.props.deleteProductUnitByProductUnitIdRequest(productUnitId);
    }
  };

  closeModal = () => {
    this.props.closeModal();
  };

  resetForm = () => {
    this.setState({
      productUnitRecord: null,
    });
  };

  render() {
    const data = {
      columns: columns,
      rows: this.state.productUnitData,
    };

    return (
      <React.Fragment>
        <CustomisedModal
          modalClass="modal-xl"
          isModalOpen={this.props.formDialog}
          modalTitle="Product Unit"
          onModalDismiss={() => this.closeModal()}
        >
          <ManageUnitForm
            resetForm={() => this.resetForm()}
            productUnitRecord={this.state.productUnitRecord}
            productDetailId={this.props.productDetailId}
          />
          <CustomDataTable data={data} />
        </CustomisedModal>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = createStructuredSelector({
  productUnitData: makeProductUnitSelectField("productUnitData"),
});

const withConnect = connect(mapStatetoProps, {
  getProductUnitByProductIdRequest,
  updateProductUnitStatusByProductUnitIdRequest,
  deleteProductUnitByProductUnitIdRequest,
});

export default compose(
  withConnect,
  withProductUnitReducer,
  withProductUnitSaga,
  withRouter
)(Index);
